import { VoiceAI } from './client';
import { providers } from './providers';

export interface STTOptions {
  language?: string;
  format?: string;
  timestamps?: boolean;
  diarization?: boolean;
  [key: string]: any;
}

export interface STTResult {
  text: string;
  confidence?: number;
  language?: string;
  segments?: Array<{
    text: string;
    start: number;
    end: number;
    confidence?: number;
  }>;
}

async function transcribe(
  audio: File | Blob | ArrayBuffer | string,
  model: string,
  options: STTOptions = {}
): Promise<STTResult> {
  const client = VoiceAI.getInstance();
  const config = client.getConfig();
  
  const provider = providers.stt[model];
  if (!provider) {
    throw new Error(
      `Model "${model}" not found. Available models: ${Object.keys(providers.stt).join(', ')}\n` +
      `Need a different model? Contact founders at hello@slng.ai`
    );
  }

  return provider.transcribe(audio, options, config);
}

export const stt = {
  async transcribe(audio: File | Blob | ArrayBuffer | string, model: string, options?: STTOptions): Promise<STTResult> {
    return transcribe(audio, model, options);
  },
  
  whisper: (audio: File | Blob | ArrayBuffer | string, options?: STTOptions) => 
    transcribe(audio, 'whisper-v3', options),
  
  kyutai: (audio: File | Blob | ArrayBuffer | string, options?: STTOptions) => 
    transcribe(audio, 'kyutai', options),
  
  models: Object.keys(providers.stt),
  
  getLanguages: (model: string): string[] => {
    const provider = providers.stt[model];
    return provider?.languages || ['en'];
  },
};